import { useEffect, useRef, useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import calendarIcon from 'src/assets/images/icons/calendar-icon-blue.png';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import styles from './DatePicker.module.scss';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import { filterDates } from 'src/redux/features';

import {
	convertISTtoUTC,
	convertUTCtoIST,
	currentDate,
	formatDate,
} from 'src/constants/utils';

import { useSelector } from 'react-redux';

export const DatePicker = ({
	onChange,
	isDateClearFilter,
	dateClearFilter,
	startDate: propStartDate,
	endDate: propEndDate,
}) => {
	const dispatch = useDispatch();
	// const filterDate = useSelector((state) => state.filterDates.filterDates);
	const initialSelectedDates = [
		{
			startDate: new Date(),
			endDate: new Date(),
			key: 'selection',
		},
	];
	const SelectedDates = [
		{
			startDate: propStartDate ? new Date(propStartDate) : new Date(),
			endDate: propEndDate ? new Date(propEndDate) : new Date(),
			key: 'selection',
		},
	];

	const [isPickerOpen, setPickerOpen] = useState(false);
	const [selectedDates, setSelectedDates] = useState([]);
	const datePickerRef = useRef(null);
	const handleOpenPicker = () => {
		setPickerOpen(true);
	};
	useEffect(() => {
		function handleClickOutside(event) {
			if (
				datePickerRef.current &&
				!datePickerRef.current.contains(event.target) &&
				!event.target.classList.contains('rdrDateRangeWrapper')
			) {
				setPickerOpen(false);
			}
		}
		document.addEventListener('click', handleClickOutside);

		// dispatch(
		//  filterDates([
		//      SelectedDates[0]?.propStartDate,
		//      SelectedDates[0]?.propEndDate,
		//  ])
		// );
		setSelectedDates([
			{
				startDate: new Date(convertUTCtoIST(SelectedDates[0]?.startDate)),
				endDate: new Date(convertUTCtoIST(SelectedDates[0]?.endDate)),
				key: 'selection',
			},
		]);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, []);

	const handleDateChange = (ranges) => {
		const { startDate, endDate } = ranges.selection;
		// Max Fixed Date Limit Removed
		// const maxEndDate = new Date(startDate);
		// maxEndDate.setDate(startDate.getDate() + 14);
		// if (endDate > maxEndDate) {
		// 	endDate.setTime(maxEndDate.getTime());
		// }
		const startUTC = moment(startDate).startOf('day').utc().format();
		const endUTC = moment(endDate).endOf('day').utc().format();

		// dispatch(filterDates([startUTC, endUTC]));
		setSelectedDates([
			{
				startDate: new Date(startUTC),
				endDate: new Date(endUTC),
				key: 'selection',
			},
		]);
	};

	const handleOKClick = () => {
		onChange(
			convertISTtoUTC(selectedDates[0]?.startDate),
			convertISTtoUTC(selectedDates[0]?.endDate)
		);
		setPickerOpen(false);
	};

	const handleCancelClick = () => {
		if (propStartDate.length !== 0 || propEndDate.length !== 0) {
			// dispatch(filterDates([startDate, endDate]));

			setSelectedDates([
				{
					startDate: new Date(propStartDate),
					endDate: new Date(propEndDate),
					key: 'selection',
				},
			]);
		} else {
			// dispatch(filterDates([]));
			setSelectedDates(initialSelectedDates);
		}
		setPickerOpen(false);
	};

	const handleClearFilter = () => {
		// dispatch(filterDates([]));

		if (isDateClearFilter) {
			setSelectedDates([
				{
					startDate: new Date(),
					endDate: new Date(),
					key: 'selection',
				},
			]);
			dateClearFilter()?.then((data) => {
				setSelectedDates([
					{
						startDate: !!data?.defaultStartDate ? new Date(data?.defaultStartDate) : new Date(),
						endDate: !!data?.defaultEndDate ? new Date(data?.defaultEndDate) : new Date(),
						showDefault: !(!!data?.defaultStartDate) && !(!!data?.defaultEndDate),
						key: 'selection',
					},
				]);
			});
		}
		setPickerOpen(false);
	};
	return (
		<>
			<div className={styles.datePickerImageDiv} ref={datePickerRef}>
				<div
					className={styles.defaultDateformat}
					onClick={handleOpenPicker}
					ref={datePickerRef}
				>
					<span className={styles.date}>
						{selectedDates[0]?.showDefault
							? 'DD/MM/YYYY'
							: selectedDates[0]?.startDate
								? formatDate(selectedDates[0]?.startDate)
								: 'DD/MM/YYYY'}{' '}
						-{' '}
						{selectedDates[0]?.showDefault
							? 'DD/MM/YYYY'
							: selectedDates[0]?.endDate
								? formatDate(selectedDates[0]?.endDate)
								: 'DD/MM/YYYY'}
					</span>
					<img
						className={styles.datePickerImage}
						src={calendarIcon}
						onClick={handleOpenPicker}
						alt="datepicker"
					/>
				</div>
				<div className={styles.datepickerStyle}>
					{isPickerOpen && (
						<>
							<DateRange
								editableDateInputs={true}
								onChange={handleDateChange}
								moveRangeOnFirstSelection={true}
								ranges={selectedDates}
								className={styles.datepickerThemeStyle}
								selectedDates={selectedDates}
								maxDate={currentDate}
							/>
							<div className={styles.buttonContainer}>
								<button
									className={styles.calenderbutton}
									onClick={handleOKClick}
								>
									OK
								</button>
								<button
									className={styles.calenderbutton}
									onClick={handleCancelClick}
								>
									Cancel
								</button>
								<button
									className={styles.clearFiltersButton}
									onClick={handleClearFilter}
								>
									Clear Filter
								</button>
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};
